import { useIsAccountLocked, usePlanKind } from '@/hooks/useTrialStatus'
import { openIntercomMessenger } from '@/hooks/useIntercom'

export function TrialExpiredBanner() {
  const isAccountLocked = useIsAccountLocked()
  const planKind = usePlanKind()

  if (!isAccountLocked) return null

  const isSubscription = planKind === 'subscription'

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 bg-gray-100 px-3 py-2 text-center text-sm text-gray-700">
      <span className="font-semibold text-gray-900">
        {isSubscription ? 'Your subscription expired.' : 'Your trial is over.'}
      </span>
      <span>
        You can no longer access clips or enable campaigns.{' '}
        {isSubscription ? 'Reactivate to unlock your account.' : 'Upgrade to unlock your account.'}
      </span>
      <button onClick={openIntercomMessenger} className="font-semibold text-primary-600 hover:text-primary-700">
        {isSubscription ? 'Reactivate' : 'Upgrade'} &rarr;
      </button>
    </div>
  )
}
